import React from 'react';
import { connect } from 'react-redux';
import { VictoryLine, VictoryChart, VictoryLabel, VictoryAxis } from 'victory';

class LineChart extends React.Component {

  constructor(props) {
    super(props);
      this.getData = this.getData.bind(this);
      this.getTitle = this.getTitle.bind(this);
      this.getLabelY = this.getLabelY.bind(this);
  }


 getData(){
   let data = [];
   let dataRecord = {};
   if ((this.props === null) || (this.props.cobiList===null)) return null;
   if (this.props.index === 1){
     if(this.props.cobiList != null){
       for (let i = 0; i < this.props.cobiList.length; i++) {
               dataRecord = this.props.cobiList[i];
               const xValue = dataRecord.time;
               const yValue = dataRecord.cell;
               data.push({x: xValue, y: yValue});
             }
       }

   } else if (this.props.index === 2){
     if(this.props.cobiList != null){
       for (let i = 0; i < this.props.cobiList.length; i++) {
               dataRecord = this.props.cobiList[i];
               const xValue = dataRecord.time;
               const yValue = dataRecord.apical;
               data.push({x: xValue, y: yValue});
             }
       }
    }else if (this.props.index === 3){
      if(this.props.cobiList != null){
        for (let i = 0; i < this.props.cobiList.length; i++) {
                dataRecord = this.props.cobiList[i];
                const xValue = dataRecord.time;
                const yValue = dataRecord.basolateral;
                data.push({x: xValue, y: yValue});
              }
        }
     }else if (this.props.index === 4){
       if(this.props.cobiList != null){
         for (let i = 0; i < this.props.cobiList.length; i++) {
                 dataRecord = this.props.cobiList[i];
                 const xValue = dataRecord.time;
                 const yValue = dataRecord.percentTransferred;
                 data.push({x: xValue, y: yValue});
               }
         }
      }

   return data;
 }

 getTitle(){
  let title = "";
   if (this.props.index === 1){
     title="Donor"
   } else if (this.props.index === 2){
      title="Membrane"
    }else if (this.props.index === 3){
       title="Receiver"
     }else if (this.props.index === 4){
        title="Percent Mass Transferred"
      }

   return title;
 }
 getLabelY(){
  let labely = "";
   if (this.props.index === 1){
     labely="Concentration (kg/m\u00B3)"
   } else if (this.props.index === 2){
      labely="Concentration (kg/m\u00B3)"
    }else if (this.props.index === 3){
       labely="Concentration (kg/m\u00B3)"
     }else if (this.props.index === 4){
       labely="Percent Transferred (%)"
      }

   return labely;
 }


  render() {
    let data = [];
    let theTitle = "Title";
    let labelY = "Label";
    const color = this.props.color;
    data = this.getData();
    theTitle = this.getTitle();
    labelY = this.getLabelY();

    return (

      <VictoryChart
        style={styles.victoryChartView}
        color={"white"}
        padding={{left:80, right: 20, top: 50, bottom: 50}}
        //domainPadding={{ y: 50, x: 200 }}
      >
      <VictoryAxis dependentAxis
          style={{
            axis: {stroke: "white"},
            tickLabels: {fill: "white"},
            axisLabel: {fontSize: 14, padding: 0},
          }}
      />
      <VictoryAxis crossAxis
      style={{
        axis: {stroke: "white"},
        tickLabels: {fill: "white"},
        axisLabel: {fontSize: 14, padding: 30},
      }}
      />
      <VictoryLabel
          style={{ fontSize: 30, fill: "white"}}
          x={165} y={10}
          text={theTitle}

        />
      <VictoryLabel
            style={{ fontSize: 12 , fill: "white"}}
            x={15} y={225}
            text={labelY}
            angle={270}
          />
      <VictoryLabel
                style={{ fontSize: 14 , fill: "white"}}
                x={250} y={290}
                text={"Time"}
              />
        <VictoryLine
          style= {{
              data: { stroke: color, strokeWidth: 2 },
              marginLeft:10,
            	marginRight:10,
            	marginTop: 20,
              strokeWidth: 1,
              parent: { border: "1px solid #ccc"},
              width: 100,
              height: '100%',
            }}
          padding= {{ top: 0, bottom: 0, left:10, right: 50 }}
          interpolation="natural"
          data={ data }
        />
      </VictoryChart>

    );
  }
}
//export default AreaChart;
export default connect(mapStateToProps, null)(LineChart);

// makes the container
function mapStateToProps(state) {

  return {
    cobiList: state.cobiList
  };
}

const styles = {
  victoryChartView: {
      width: '100%',
      //height: '100%',
      marginLeft:0,
    	marginRight:0,
    	marginTop: 0,
      data: { stroke: "#c43a31", strokeWidth: 1 },
      parent: { border: "1px solid #015f82"}
    },

    victoryLineChartView: {
        width: '80%',
        //height: '90%',
        marginLeft:0,
      	marginRight:0,
      	marginTop: 0,
        strokeWidth: 5,
        padding:{ top: 0, bottom: 0, left: 20, right: 0 },
        parent: { border: "1px solid #ccc"}
      },

}



// WEBPACK FOOTER //
// ./src/components/charts/lineChart.js